import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { Certifications } from './components/Certifications';
import { ServicesOverview } from './components/ServicesOverview';
import { ServiceDetails } from './components/ServiceDetails';
import { ProcessSteps } from './components/ProcessSteps';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { TaxPreparationPage } from './components/TaxPreparationPage';
import { DownloadGuideSection } from './components/DownloadGuideSection';
import { ContactPage } from './components/ContactPage';
function HomePage() {
  return <div className="font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <ServicesOverview data-id="element-3" />
      <ServiceDetails data-id="element-4" />
      <ProcessSteps data-id="element-5" />
      <Testimonials data-id="element-6" />
      <AboutSection data-id="element-7" />
      <Certifications data-id="element-8" />
      <DownloadGuideSection data-id="element-9" />
      <FAQ data-id="element-10" />
      <CTASection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/" element={<HomePage data-id="element-16" />} data-id="element-15" />
        <Route path="/tax-preparation" element={<TaxPreparationPage data-id="element-18" />} data-id="element-17" />
        <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}